/** 主题预设：5 套与 Sugár logo 协调的配色方案。
    RGB 值存为空格分隔字符串，供 Tailwind `rgb(var(--color-brand) / <alpha>)` 使用。 */

export interface ThemePreset {
  key: string
  name: string
  light: { brand: string; accent: string; brandSoft: string }
  dark: { brand: string; accent: string; brandSoft: string }
}

export const THEME_PRESETS: ThemePreset[] = [
  {
    key: 'crimson',
    name: '经典红',
    light: { brand: '196 18 48', accent: '230 57 70', brandSoft: '254 226 230' },
    dark: { brand: '230 57 70', accent: '248 113 113', brandSoft: '59 17 20' },
  },
  {
    key: 'ocean',
    name: '海洋蓝',
    light: { brand: '29 78 216', accent: '59 130 246', brandSoft: '219 234 254' },
    dark: { brand: '96 165 250', accent: '147 197 253', brandSoft: '30 42 74' },
  },
  {
    key: 'forest',
    name: '森林绿',
    light: { brand: '4 120 87', accent: '16 185 129', brandSoft: '209 250 229' },
    dark: { brand: '52 211 153', accent: '110 231 183', brandSoft: '15 46 36' },
  },
  {
    key: 'sunset',
    name: '暖阳橙',
    light: { brand: '194 65 12', accent: '234 88 12', brandSoft: '255 237 213' },
    dark: { brand: '251 146 60', accent: '253 186 116', brandSoft: '59 31 11' },
  },
  {
    key: 'royal',
    name: '皇家紫',
    light: { brand: '124 58 237', accent: '139 92 246', brandSoft: '237 233 254' },
    dark: { brand: '167 139 250', accent: '196 181 253', brandSoft: '45 27 78' },
  },
]

export function getPresetByKey(key: string): ThemePreset {
  return THEME_PRESETS.find((p) => p.key === key) ?? THEME_PRESETS[0]
}
